<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
  <path d="M11 3.5H19.5C20.0523 3.5 20.5 3.94772 20.5 4.5V19.5C20.5 20.0523 20.0523 20.5 19.5 20.5H11" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M8.5 7.5L3.5 12L8.5 16.5" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
  <path d="M16 12H4" stroke="#000" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
</svg>
